<div class="value-selector" *ngIf="setting">
    <div *ngIf="isMultiSelect" class="value-selector__multi">
        <div *ngFor="let value of allowableValues" class="value-selector__multi__choice">
            <input type="radio" [id]="'value-' + value.value" (click)="onSelectOption($event)" [disabled]="unpinValue"
                name="multiSelect" [value]="value.value" [checked]="value.value.toLowerCase() == currentValue.toLowerCase()">
            <label [id]="'label-' + value.value" [for]="'value-' + value.value">{{ value.label }}</label>
            <span class="value-selector__multi__units" *ngIf="setting.units">{{setting.units}}</span>
        </div>
    </div>

    <div *ngIf="!isMultiSelect" class="value-selector__text">
        <input id="text-input" [type]="fieldInputType" [(ngModel)]="currentValue" [disabled]="unpinValue">
        <span *ngIf="setting.units">{{setting.units}}</span>
    </div>

    <input id="unpin" type="checkbox" [(ngModel)]="unpinValue">
    <label for="unpin">Unpin Value</label>

    <div class="value-selector__footer">
        <span id='add-button' (click)="onAddSetting()">{{buttonLabel}}</span>
    </div>
</div>
